import React from 'react';
import { View, type ImageSourcePropType, ImageBackground } from 'react-native';
import Text from '../Text';

interface BannerImageList {
  mobile: ImageSourcePropType;
  web: ImageSourcePropType;
}

interface Props {
  insuranceName: string;
  insuranteDetail: string;
  images: BannerImageList;
  horizontal?: boolean;
  hired?: boolean;
  className?: string;
}

const HireBanner: React.FC<Props> = ({
  images: { mobile, web },
  insuranceName,
  insuranteDetail,
  horizontal = false,
  hired = false,
  className,
}) => {
  if (horizontal) {
    return (
      <ImageBackground
        source={web}
        resizeMode="cover"
        className={`${hired ? 'h-[187px]' : 'h-[220px]'}  ${className}`}
        imageStyle={{ borderRadius: 8 }}
      >
        <View
          className={`pl-6 w-[55%] absolute h-full ${
            hired ? 'justify-between py-4' : 'justify-center'
          }`}
        >
          <View className="px-2 bg-success-600 mr-auto rounded-[100px]">
            {hired && (
              <Text className="text-xs text-light-100 font-normal">
                Contratado
              </Text>
            )}
          </View>
          <View>
            <Text className="text-light-100 text-[24px] font-bold">
              {insuranceName}
            </Text>

            <Text className="text-light-100 mt-2 text-lg">
              {insuranteDetail}
            </Text>
          </View>
        </View>
      </ImageBackground>
    );
  }

  return (
    <>
      <ImageBackground
        source={mobile}
        resizeMode="cover"
        className={`${
          hired ? 'h-[187px] lg:hidden' : 'h-[115px] lg:hidden'
        }  ${className}`}
      >
        <View
          className={`pl-6 w-[55%]  absolute h-full ${
            hired ? 'justify-between py-4' : 'pt-6'
          }`}
        >
          <View className="px-2 bg-success-600 mr-auto rounded-[100px]">
            {hired && (
              <Text className="text-xs text-light-100 font-normal">
                Contratado
              </Text>
            )}
          </View>
          <View>
            <Text className="text-light-100 text-lg font-bold">
              {insuranceName}
            </Text>

            <Text className="text-light-100 mt-2 text-sm">
              {insuranteDetail}
            </Text>
          </View>
        </View>
      </ImageBackground>

      <ImageBackground
        source={web}
        className="w-[518px] h-[669px] hidden lg:block"
      />
    </>
  );
};

export default HireBanner;
